<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g flex">
                    <div class="g inner">
                        <div class="md caption">{{ $t('site.func.login') }}</div>
                        <div class="fieldset">
                            <label>{{ $t('site.noun.userid') }}</label>
                            <div
                                v-if="lock"
                                class="cp input text"
                                disabled
                            >
                                <input :value="id" type="text" disabled>
                            </div>
                            <div
                                v-else
                                class="cp input text"
                                :class="[errors.has('id')? 'is-error': '']"
                                :data-error="errors.first('id')"
                            >
                                <input v-model="id" type="text" v-validate="getValidate" name="id" id="id">
                            </div>
                        </div>
                        <div class="fieldset">
                            <label>{{ $t('site.noun.password') }}</label>
                            <div class="cp input password" :class="[errors.has('password')? 'is-error': '']" :data-error="errors.first('password')">
                                <input v-model="password" type="password" v-validate="'required'" name="password" id="password" @keypress.enter="login">
                            </div>
                        </div>
                        <div class="g btn">
                            <mdBtnList
                                :content="leftBtns"
                                :block="true"
                                @sendEvent="receiveEvent"
                            ></mdBtnList>
                        </div>
                        <!-- <a class="link" :href="$siteConfig.exportUrl"> {{ $t('site.func.connectb2b') }}</a> -->
                    </div>
                    <div
                        v-if="!user.accountid"
                        class="g inner left"
                    >
                        <div class="md content">
                            {{ $t('popup.signin.item.register') }}
                        </div>
                        <div class="g btn">
                            <mdBtnList
                                :content="rightBtns"
                                :block="true"
                                @sendEvent="receiveEvent"
                            ></mdBtnList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import gFieldset from '@/components/gFieldset'
    import mdToggleAside from '@/components/mdToggleAside'
    import gRow from '@/components/gRow'
    import gCell from '@/components/gCell'
    import gForm from '@/components/gForm'
    import mdBtnList from '@/components/mdBtnList'

    import { mapState, mapActions, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            gFieldset,
            mdToggleAside,
            gRow,
            gCell,
            gForm,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                require: false,
                default: () => {
                    return {}
                }
            }
        },
        data: function(){
            let _id = '',
                _lock = false;

            if( this.content.id ) {
                _id = this.content.id;
                _lock = true;
            }

            return {
                lock: _lock,
                id: _id,
                password: '',
            }
        },
        computed: {
            ...mapState([
                'user',
                'path',
            ]),
            getValidate: function(){
                let _result = 'required';

                let $user = this.user,
                    _accountid = $user.accountid;

                if( _accountid ) {

                    _result = _result +'|notInclude:'+ _accountid;
                }

                return _result;
            },
            leftBtns: function(){

                return [
                    {
                        text: this.$t('site.func.login'),
                        themes: 'major',
                        func: 'login',
                    }
                ]
            },
            rightBtns: function(){

                return [
                    {
                        text: this.$t('site.func.register'),
                        themes: 'major',
                        func: 'signup',
                    }
                ]
            },
        },
        methods: {
            ...mapActions([
                'getAuth'
            ]),
            ...mapMutations([
                'changeState',
                'pushNotification',
            ]),
            login: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {

                        this.getAuth({
                            account: this.id,
                            password: this.password,
                            callback: () => {
                                let $content = this.content,
                                    $_callback = $content.callback;

                                if( $_callback && typeof $_callback === 'function' ) {
                                    $_callback();
                                }

                                let $goOutsideList = [
                                        '/system/signup',
                                        '/system/account',
                                    ]

                                if( $goOutsideList.includes(this.$route.path) ) {
                                    this.$router.push('/index')
                                }

                                this.close();   
                            }
                        });
                    }
                });
            },
            signup: function(){
                this.$router.push('/system/signup');
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .g.pop-up-content-inner {
        padding: $interval-xl 0;
    }

    .md.caption {
        text-align: center;
        font-size: $font-size-xl;
        color: $major-color;
        margin-bottom: $interval-l;
    }

    .g.flex {
        display: flex;

        @include media('mobile') {
            display: block;
        }
    }

    .g.inner {
        width: 250px;
        padding: 0 $interval-xl;

        @include media('phone') {
            margin: 0 auto;
            padding: 0;
        }

        &.left {
            border-left: $border;
            padding-top: 90px;

            @include media('mobile') {
                padding-top: 30px;
                border-left-width: 0;
            }
        }
    }

    .g.btn {
        padding-top: $interval-l;
    }

    .fieldset {
        padding: $interval-xs 0;

        label {
            display: block;
            margin-bottom: $interval-s;
        }
    }

    .link {
        display: block;
        text-align: right;
        font-size: $font-size-s;
    }
</style>
